import * as React from 'react'

import { Button } from '~/client/src/shared/components/Button/Button'
import Localization from '~/client/src/shared/localization/LocalizationManager'

interface IProps {
  name: string
  currentIndex: number
  total: number
  onPlace: (e: React.MouseEvent) => void
  onCancel: (e: React.MouseEvent) => void
}

export default function PendingPlacementToolbar({
  name,
  currentIndex,
  total,
  onPlace,
  onCancel,
}: IProps) {
  return (
    <div className="tw:mt-2 tw:flex tw:flex-col tw:gap-2 tw:rounded-2xl tw:border tw:border-md3-surface-container-highest tw:bg-md3-on-primary tw:px-3 tw:py-2 tw:shadow-[0px_1px_2px_rgba(0,0,0,0.3),0px_2px_6px_rgba(0,0,0,0.15)]">
      <div className="tw:flex tw:items-center tw:justify-between tw:gap-3">
        <span
          className="tw:truncate tw:text-label-lg-prominent tw:text-md3-on-surface"
          title={name}
        >
          {name}
        </span>
        {total > 1 && (
          <span className="tw:whitespace-nowrap tw:text-label-sm tw:text-md3-on-surface-variant">
            {currentIndex} / {total}
          </span>
        )}
      </div>
      <div className="tw:flex tw:gap-2">
        <Button size="sm" variant="outline" onClick={onCancel}>
          {Localization.translator.cancel}
        </Button>
        <Button size="sm" onClick={onPlace}>
          {Localization.translator.placeHere}
        </Button>
      </div>
    </div>
  )
}
